<template>
  <div
    class="p-5 rounded-md shadow-lg bg-depth-3"
    :data-testid="testId([title, 'faq'])"
  >
    <div
      class="flex items-center cursor-pointer gap-4"
      @click="() => emit('toggleAnswer')"
    >
      <div class="size-8 shrink-0">
        <strapi-image
          v-if="iconUrl"
          :image="iconUrl"
          :alt="title"
          image-class="w-full h-full object-contain"
        />
      </div>
      <div class="grow text-xl font-bold leading-none">
        {{ title }}
      </div>
      <div class="shrink-0 text-center">
        <fa-icon
          v-if="isOpened"
          class="size-4 text-rhino"
          :icon="faMinus"
          aria-hidden="true"
        />
        <fa-icon
          v-else
          class="size-4 text-rhino"
          :icon="faPlus"
          aria-hidden="true"
        />
      </div>
    </div>

    <div class="py-5 mt-5 border-t border-rhino" :class="{ hidden: !isOpened }">
      <common-md-content
        v-if="content"
        v-slot="{ renderedContent }"
        :content="content"
      >
        <div v-once v-html="renderedContent"></div>
      </common-md-content>
    </div>
  </div>
</template>

<script setup lang="ts">
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';
import type { StrapiImage } from '~/apollo/types/types';
import testId from '~/helpers/testid';

defineOptions({
  name: 'StrapiFaqItem',
});

withDefaults(
  defineProps<{
    content: string;
    title: string;
    iconUrl?: StrapiImage | null;
    isOpened?: boolean;
  }>(),
  {
    iconUrl: null,
    isOpened: false,
  },
);

const emit = defineEmits<{
  (e: 'toggleAnswer'): void;
}>();
</script>
